import Device from '@/data/device.js'

const tabletBreakpoint = 900
const mobileHeightBreakpoint = 667
const device = new Device()

const refreshDeviceState = (commit) => {
    device.detect()
    commit('UPDATE_MOBILE_SIZE', window.innerWidth < tabletBreakpoint)
    commit('UPDATE_MOBILE_AGENT', device.isType('mobile') || device.isType('tablet'))
    commit('UPDATE_IS_IE', device.isBrowser('ie'))
    commit('UPDATE_IS_FIREFOX', device.isBrowser('firefox'))
    commit('UPDATE_IS_CHROME', device.isBrowser('chrome'))
    commit('UPDATE_IS_SAFARI', device.isBrowser('safari'))
    commit('UPDATE_IS_IOS', device.isMobileOs('ios'))
    commit('UPDATE_IS_ANDROID', device.isMobileOs('android'))
    commit('UPDATE_VIEWPORT_SIZE')
    commit('UPDATE_KEYBOARD_ACTIVE', device.isVirtualKeyboard('active'))
    commit('UPDATE_ORIENTATION', device.get('orientation'))
    commit('UPDATE_TYPE', device.get('type'))
}

const state = {
    isIE: false,
    isFirefox: false,
    isSafari: false,
    isChrome: false,
    isIOS: false,
    isAndroid: false,
    deviceViewPort: {},
    isMobileSize: false,
    isSmallDevice: false,
    isTypeMobile: false,
    isTypeTablet: false,
    isTypeDesktop: false,
    isKeyboardActive: false,
    mobileOrientation: '',
    updatedViewPort: {}
}

const getters = {
    isIE: state => state.isIE,
    isFirefox: state => state.isFirefox,
    isSafari: state => state.isSafari,
    isChrome: state => state.isChrome,
    isIOS: state => state.isIOS,
    isAndroid: state => state.isAndroid,
    isMobileSize: state => state.isMobileSize,
    isSmallDevice: state => state.isSmallDevice,
    isTypeMobile: state => state.isTypeMobile,
    isTypeTablet: state => state.isTypeTablet,
    isTypeDesktop: state => state.isTypeDesktop,
    deviceViewPort: state => state.deviceViewPort,
    isKeyboardActive: state => state.isKeyboardActive,
    mobileOrientation: state => state.mobileOrientation,
    deviceOrientation: state => state.mobileOrientation,
    updatedViewPort: state => state.updatedViewPort
}

const actions = {
    monitorDeviceInfo({ commit }) {
        refreshDeviceState(commit)

        device.on('propertiesUpdate', () => {
            refreshDeviceState(commit)
        })
        device.on('virtualKeyboardUpdate', () => {
            commit('UPDATE_KEYBOARD_ACTIVE', device.isVirtualKeyboard('active'))
        })
        device.on('viewPortUpdated', ({ viewPortWidth, viewportHeight}) => {
            commit('UPDATE_VIEWPORT_SIZE_KEYBOARD', {
                viewPortWidth,
                viewportHeight
            })
        })
    }
}

const mutations = {
    ['UPDATE_TYPE'](state, type) {
        state.isTypeDesktop = type === 'desktop'
        state.isTypeMobile = type === 'mobile'
        state.isTypeTablet = type === 'tablet'
    },
    ['UPDATE_ORIENTATION'](state, mobileOrientation) {
        state.mobileOrientation = mobileOrientation
    },
    ['UPDATE_KEYBOARD_ACTIVE'](state, isKeyboardActive) {
        state.isKeyboardActive = isKeyboardActive
    },
    ['UPDATE_VIEWPORT_SIZE_KEYBOARD'](state, { viewPortWidth, viewportHeight}) {
        state.updatedViewPort = {
            width: viewPortWidth,
            height: viewportHeight
        }
    },
    ['UPDATE_VIEWPORT_SIZE'](state) {
        state.deviceViewPort = {
            width: window.innerWidth,
            height: window.innerHeight
        }
        state.isSmallDevice = state.deviceViewPort.height < mobileHeightBreakpoint
    },
    ['UPDATE_IS_IOS'](state, isIOS) {
        state.isIOS = isIOS
    },
    ['UPDATE_IS_ANDROID'](state, isAndroid) {
        state.isAndroid = isAndroid
    },
    ['UPDATE_IS_IE'](state, isIE) {
        state.isIE = isIE
    },
    ['UPDATE_IS_FIREFOX'](state, isFirefox) {
        state.isFirefox = isFirefox
    },
    ['UPDATE_IS_CHROME'](state, isChrome) {
        state.isChrome = isChrome
    },
    ['UPDATE_IS_SAFARI'](state, isSafari) {
        state.isSafari = isSafari
    },
    ['UPDATE_MOBILE_AGENT'](state, isMobileAgent) {
        state.isMobileAgent = isMobileAgent
    },
    ['UPDATE_MOBILE_SIZE'](state, isMobileSize) {
        state.isMobileSize = isMobileSize
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}
